module.exports = __webpack_public_path__ + "438a42cb0f975b9964e12d01557eb144.png";